import { useState } from 'react';
import ArticleLayout from '@/components/ArticleLayout';

const faqs = [
  {
    q: 'What is CSSBuy Spreadsheet?',
    a: 'CSSBuy Spreadsheet is an organized guide to resources, products, and links related to CSSBuy. It helps buyers research and compare products in categories like shoes, clothing, accessories, and more.',
  },
  {
    q: 'How does CSSBuy Spreadsheet work?',
    a: 'You navigate through categories, find products and links, consult buying guides, and compare options before making purchase decisions. The spreadsheet format organizes information for easy reference.',
  },
  {
    q: 'Is CSSBuy Spreadsheet free?',
    a: 'Yes, this is a free independent informational resource. We do not charge for access to our guides and research content.',
  },
  {
    q: 'How do I check a CSSBuy product?',
    a: 'Consult QC guides, verify seller reputation, check current prices, and review community feedback before making any purchase. Always verify information directly on the official CSSBuy platform.',
  },
  {
    q: 'Is CSSBuy legit?',
    a: 'CSSBuy is a known buying agent platform. However, as with any online platform, users should always verify sellers, check product links, and review QC photos before purchasing. Exercise standard online shopping precautions.',
  },
  {
    q: 'How does CSSBuy shipping work?',
    a: 'CSSBuy shipping depends on multiple factors including weight, volume, destination country, and chosen shipping line. Items are stored in the warehouse until you submit a shipping request with your preferred method.',
  },
  {
    q: 'How does CSSBuy QC work?',
    a: 'QC (Quality Control) means the warehouse inspects your items when they arrive and takes photos. You review these photos and can approve or request exchanges before the items are shipped to you.',
  },
  {
    q: 'How much does CSSBuy shipping cost?',
    a: 'Shipping costs vary based on package weight, dimensions, destination, and shipping line. CSSBuy provides estimates, but actual costs depend on the final packaged parcel. Check current rates on the official platform.',
  },
  {
    q: 'What is the CSSBuy warehouse process?',
    a: 'The typical process is: Order -> Warehouse Arrival -> QC Photos -> Storage (up to a limit) -> Consolidation (optional) -> Shipping Request -> Dispatch to your address.',
  },
  {
    q: 'Can I get a refund on CSSBuy?',
    a: 'Refund policies depend on the seller and the stage of the order. Items that have not been purchased yet may be cancelable. Purchased items may have limited return options. Check CSSBuy\'s current policies for details.',
  },
];

export default function FaqPage() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <ArticleLayout
      title="Frequently Asked Questions"
      description="Common questions about CSSBuy Spreadsheet, shipping, QC, and buying guides."
      breadcrumbs={[
        { label: 'Home', to: '/' },
        { label: 'FAQ', to: '/faq' },
      ]}
      lastUpdated="2026-08-30"
    >
      <div className="space-y-3">
        {faqs.map((faq, index) => (
          <div key={index} className="bg-background-50 border border-background-200 rounded-xl overflow-hidden">
            <button
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
              className="w-full flex items-center justify-between px-5 py-4 text-left"
            >
              <span className="text-sm font-medium text-foreground-900">{faq.q}</span>
              <i className={`ri-arrow-down-s-line text-lg text-foreground-500 transition-transform ${openIndex === index ? 'rotate-180' : ''}`}></i>
            </button>
            {openIndex === index && (
              <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                {faq.a}
              </div>
            )}
          </div>
        ))}
      </div>
    </ArticleLayout>
  );
}